import chapter1 from '@/store/data/chapter-1.js';
import chapter2 from '@/store/data/chapter-2.js';
import chapter3 from '@/store/data/chapter-3.js';
import chapter4 from '@/store/data/chapter-4.js';
import chapter5 from '@/store/data/chapter-5.js';
// https://www.narscosmetics.com/on/demandware.static/-/Library-Sites-NARS-Shared-Library/en_US/v1723528465856/
export default [
  {
    hero: {
      image: {
        desktop: "https://www.narscosmetics.com/on/demandware.static/-/Library-Sites-NARS-Shared-Library/en_US/v1723528465856/clp/2024/08-anniversary/images/hero/webp/chapter-2@2x.webp",
        mobile: "https://www.narscosmetics.com/on/demandware.static/-/Library-Sites-NARS-Shared-Library/en_US/v1723528465856/clp/2024/08-anniversary/images/hero/webp/mobile/dpr-3/chapter-2@4x.webp",
      },
      title: "chapter-2.title",
    },
    content: chapter2
  },
  {
    hero: {
      image: {
        desktop: "https://www.narscosmetics.com/on/demandware.static/-/Library-Sites-NARS-Shared-Library/en_US/v1723528465856/clp/2024/08-anniversary/images/hero/webp/chapter-3@2x.webp",
        mobile: "https://www.narscosmetics.com/on/demandware.static/-/Library-Sites-NARS-Shared-Library/en_US/v1723528465856/clp/2024/08-anniversary/images/hero/webp/mobile/dpr-3/chapter-3@4x.webp",
      },
      title: "chapter-3.title",
    },
    content: chapter3
  },
  {
    hero: {
      image: {
        desktop: "https://www.narscosmetics.com/on/demandware.static/-/Library-Sites-NARS-Shared-Library/en_US/v1723528465856/clp/2024/08-anniversary/images/hero/webp/chapter-4@2x.webp",
        mobile: "https://www.narscosmetics.com/on/demandware.static/-/Library-Sites-NARS-Shared-Library/en_US/v1723528465856/clp/2024/08-anniversary/images/hero/webp/mobile/dpr-3/chapter-4@4x.webp",
      },
      title: "chapter-4.title",
    },
    content: chapter4
  },
  {
    hero: {
      image: {
        desktop: "https://www.narscosmetics.com/on/demandware.static/-/Library-Sites-NARS-Shared-Library/en_US/v1723528465856/clp/2024/08-anniversary/images/hero/webp/chapter-5@2x.webp",
        mobile: "https://www.narscosmetics.com/on/demandware.static/-/Library-Sites-NARS-Shared-Library/en_US/v1723528465856/clp/2024/08-anniversary/images/hero/webp/mobile/dpr-3/chapter-5@4x.webp",
      },
      title: "chapter-5.title",
    },
    content: chapter5
  }
]